/* eslint-disable react/jsx-indent */
import React, { Component } from 'react'
import { Card, CardBody, Row, Col } from 'reactstrap'
import ReactApexChart from 'react-apexcharts'
import api_powerapps from '../../services/powerapps/index'
import graphRequest from '../graphRequest/index'
import countBy from '../array/countBy'
import defaultColors from '../../constants/ChartsDefaultColors'
import currencyFormatter from '../currencyFormatter'

function getColor(string) {
  const str = string.split(' ').map(i => i.charAt(0)).join('')
  let sum = 0
  for (let i = 0; str.length > 2 ? i < 2 : i < str.length; i++) {
    sum += str.charCodeAt(i)
  }
  if (sum > 100) sum -= 100
  sum = Math.ceil(Math.random() * 100)
  return defaultColors[sum]
}

class PieChart extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: false,
      getDataIsLoading: false,
      labels: false,
      colors: false,
      values: false,
      pontos: false,
    }
  }

  componentDidMount() {
    this.getData()
  }

  componentDidUpdate(prevProps) {
    if (this.props.pars !== prevProps.pars) {
      this.getData()
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  getData = async () => {
    this.setState({ getDataIsLoading: true })
    const formData = new FormData()
    let res
    let colors
    let labels
    let values

    if (this.props.src === 'sharepoint') {
      const { siteId, listId, pars, countby } = this.props
      try {
        const aux_data = await graphRequest(siteId, listId, pars)
        const data = countBy(countby, aux_data)
        labels = Object.keys(data)
        colors = labels.map(label => getColor(label))
        const valuesRaw = Object.values(data)
        values = valuesRaw.map(value => Number((value).toFixed(0)))
        const pontos = data.map((reg, index) => ({
          label: labels[index],
          value: values[index],
          color: colors[index],
        }))
        this.setState({ getDataIsLoading: false, data, colors, labels, values, pontos })
      } catch (err) {
        this.setState({ getDataIsLoading: false, data: false })
        console.tron.log('Não foi possível carregar a série de dados para o piechart a partir do SharePoint.', err)
      }
    } else {
      try {
        formData.append('acao', this.props.req)
        formData.append('groupby', this.props.groupby)
        formData.append('pars', this.props.pars)
        res = await api_powerapps.post('/', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: 'multipart/form-data',
          },
        })
        console.tron.log('data', Object.values(res.data))
        const { data } = res
        labels = Object.keys(data[0])
        colors = labels.map(label => getColor(label))
        const valuesRaw = Object.values(data[0])
        values = valuesRaw.map(value => Number((value).toFixed(2)))
        console.log(data[0])
        const pontos = labels.map((reg, index) => ({
          label: labels[index],
          value: values[index],
          color: colors[index],
        }))
        console.log(pontos)
        this.setState({ getDataIsLoading: false, data: data[0], colors, labels, values, pontos })
      } catch (err) {
        this.setState({ getDataIsLoading: false, data: false })
        console.tron.log('Não foi possível carregar a série de dados para o piechart a partir do MySQL.', err)
      }
    }
  }

  render() {
    const { title, legend } = this.props
    const { getDataIsLoading, data, colors, labels, values, pontos } = this.state

    if (getDataIsLoading) {
      return (
        <Card>
          <CardBody>
            <h4 className="card-title mb-4">{title}</h4>
            <span>Carregando...</span>
          </CardBody>
        </Card>
      )
    }

    if (data) {
      return (
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <h4 className="card-title mb-4">{title}</h4>
                </Col>
              </Row>
              <div id="donut-chart" className="apex-charts mt-3">
                <ReactApexChart
                  options={{
                    labels,
                    plotOptions: {
                      pie: {
                        donut: {
                          size: '75%',
                        },
                      },
                    },
                    dataLabels: {
                      enabled: false,
                    },
                    legend: {
                      show: true,
                      horizontalAlign: 'right',
                      width: 350
                    },
                    colors,
                  }}
                  series={values}
                  type="pie"
                  height="230"
                />
              </div>

              {legend ? (
              <Row>
                {pontos.map(ponto => (
                  <Col xs={4} key={ponto.label}>
                    <div className="text-center mt-3" title={`${ponto.label} (${(ponto.value).toFixed(0)}%)`}>
                      <p className="mb-2 text-truncate">
                        <i className="mdi mdi-circle font-size-10 mr-1" style={{ color: ponto.color }} />
                        {' '}
                        {ponto.label}
                      </p>
                      <h5>{`${(ponto.value).toFixed(0)}%`}</h5>
                    </div>
                  </Col>
                ))}
              </Row>
              ) : (null) }

            </CardBody>
          </Card>
      )
    }

    return null
  }
}
export default PieChart
